import { FC } from 'react';
import { IconButton } from '@chakra-ui/react';
import Gleap from 'gleap';
import { ICON_BY_NAME } from '..';
interface SupportButtonProps {
  isMobile?: boolean;
}
export const SupportButton: FC<SupportButtonProps> = ({
  isMobile = false
}) => {
  return <IconButton aria-label="get-support-button" onClick={() => Gleap.open()} _focus={{
    border: 'none'
  }} backgroundColor="luigisPants.500" _hover={{
    backgroundColor: 'luigisPants.400'
  }} borderRadius={50} marginLeft={isMobile ? 0 : 2} size="sm" icon={<ICON_BY_NAME.questioncirclehollow height={8} width={8} color="kirby.300" />} data-sentry-element="IconButton" data-sentry-component="SupportButton" data-sentry-source-file="SupportButton.tsx" />;
};